import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import "./ui/theme.css";
import "./index.css";
import "./Utils/axiosSetup";
import App from "./App";
import "./ui/mobile.css";
import "./i18n/rtl.css";
import { BrowserRouter } from "react-router-dom";
import ChatProvider from "./Context/ChatProvider";
import I18nProvider from "./i18n/I18nProvider";
import { ConfirmProvider } from "./ui";

// Apply the saved theme before first paint to avoid a light flash in dark mode.
try {
  document.documentElement.setAttribute("data-theme", localStorage.getItem("gq-theme") || "light");
} catch (e) {
  /* storage unavailable */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChatProvider>
    <BrowserRouter>
      <I18nProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </I18nProvider>
    </BrowserRouter>
  </ChatProvider>
);
